"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const NotificationDot = _ref => {
  let {
    dataTest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-test": dataTest,
    className: "absolute size-200 bg-red-normal border border-white top-[10px] end-100 z-navigation-bar rounded-full"
  });
};
var _default = exports.default = NotificationDot;